/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { FormProvider } from "cms/forms/context/form.provider";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { ComposerForm } from "./composer-form";

const FormsComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const { form_id, title } = component || {};
    const hasContent = !!form_id;
    
    return (
        <FormProvider>
            {hasContent &&
                <ComposerForm
                    form_id={form_id}
                    title={title}
                />
            }
            {!hasContent &&
                <EmptyContentMessage
                    hasContent={hasContent}
                    component={component}
                />
            }
        </FormProvider>
    );
};

FormsComponentDisplay.displayName = "FormsComponentDisplay";
export { FormsComponentDisplay };
